<template>
	<van-empty class="base_empty" :description="desc">
		<template #image>
			<img class="empty_img" :src="icons[icon]" :alt="desc" :title="desc" />
		</template>
	</van-empty>
</template>

<script>
export default {
	name: 'BaseEmpty',
	props: {
		desc: {
			type: String,
			default: ''
		},
		icon: {
			type: Number,
			default: 0
		}
	},
	data: () => ({
		icons: [
			require(`@/assets/img/empty_1.png`),
			require(`@/assets/img/empty_2.png`),
			require(`@/assets/img/empty_3.png`)
		]
	})
};
</script>


<style lang="less">
	.base_empty {
		.empty_img {
			width: 313px;
			object-fit: contain;
			vertical-align: middle;
		}
		.van-empty {
			padding-top: 300px;
			.van-empty__image {
				height: initial;
			}
			.van-empty__description {
				font-family: PingFangSC-Regular;
				font-size: 26px;
				font-weight: normal;
				line-height: 31px;
				color: #8F959E;
			}
		}
	}
</style>
